import { TestImage } from "@assets/constant/index.constant";
import { GeneralCard, TableCard } from "@ui/internal/components/card";

import { endpoint } from "@services/api.services";
import { showToast } from "@utils/helper/index.helper";
import { usePathname } from "@utils/hook/index.hook";
import { METHODS, QueryData } from "@utils/interface/index.interface";
import { CategoryData, DurationData } from "@utils/interface/journey.interface";
import { useListData, usePostData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import { format } from "date-fns";
import { useNavigate, useParams, useSearchParams } from "react-router";
import { CategoryColumnList } from "../column/index.column";
import CategoryForm from "../form";
import FilterPopover from "@ui/internal/components/filter-popover";
import { Button } from "@components/ui/button";
import { ChevronLeft } from "lucide-react";

type Params = {
  setup: "categories" | "duration" | "batch" | "&-batch";
};
const BlogCategories = () => {
  const pathname = usePathname();
  const { setup } = useParams<Params>();
  const [searchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  console.log(pathname, "pathname");
  /* ================================================= api calls logic ================================================= */
  let { data, isPending, refetch } = useListData<
    QueryData<CategoryData | DurationData>
  >({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
      section:
        searchParams
          .get("data-category")
          ?.toLocaleLowerCase()
          ?.split("-")[0] === "all"
          ? ""
          : searchParams
              .get("data-category")
              ?.toLocaleLowerCase()
              ?.split("-")[0] || "",
      is_show: searchParams.get("is_show") || "",
    },

    endpoint: endpoint["blog-category"],
    key: `${pathname}-listing`,
    window: true,
  });

  const { mutate } = usePostData();

  const toggleActiveStatus = (id: string | number, state: boolean) => {
    mutate(
      {
        endpoint: endpoint["blog-category"],

        data: {
          is_show: state,
          id,
        },
        method: METHODS.PATCH,
      },
      {
        onSuccess: () => {
          if (data) {
            data.data.results = data.data.results.map((item) =>
              item.id === id ? { ...item, is_show: state } : item
            );
            showToast({
              title: "Category updated successfully",
              description: "Category updated successfully",
              type: "success",
            });
          }
        },
        onError: (data) => {
          console.log(data);
        },
      }
    );
  };
  const navigate = useNavigate();
  const columns = CategoryColumnList({ refetch, toggleActiveStatus });
  return (
    <>
      <TableCard
        bulkActions
        table_content={{
          mode: "default",
          type: pathname,
        }}
        form={<CategoryForm />}
        formId={pathname}
        isOrientation={false}
        orientationPosition={false}
        grid={
          <GeneralCard
            isChecked={false}
            type={"mentor"}
            content={{
              images: [TestImage, TestImage, TestImage],
              title: "Aayush Maharjan",
              subtitle: "Frontend Developer",
            }}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        columns={columns}
        refetch={refetch}
        isPending={isPending}
        inject_ui_table_actions={
          <>
            {/* <Button
              variant={"defaultoutline"}
              onClick={() => navigate("/blogs")}
            >
              <ChevronLeft /> Go Back
            </Button> */}
            <FilterPopover
              filters={[
                {
                  label: "Visibility",
                  searchKey: "is_show",
                  defaultOptions: [
                    {
                      label: "Shown",
                      value: "true",
                    },
                    {
                      label: "Hidden",
                      value: "false",
                    },
                  ],
                },
              ]}
              title="Filter"
              triggerText="Filter"
            />
          </>
        }
        rows={data?.data?.results ?? []}
        endpoint={endpoint["blog-category"]}
        sortableFilter={{
          search: search,
          created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
          created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
          is_show: searchParams.get("is_show") || "",
          ordering: searchParams.get("ordering") || "order",
          section:
            searchParams
              .get("data-category")
              ?.toLocaleLowerCase()
              ?.split("-")[0] === "all"
              ? ""
              : searchParams
                  .get("data-category")
                  ?.toLocaleLowerCase()
                  ?.split("-")[0] || "",
        }}
        count={data?.data?.count ?? 10}
      />
    </>
  );
};

export default BlogCategories;
